import * as React from 'react';
import { observer } from 'mobx-react';

import { Button, Row, Col, Divider } from 'antd';
import TaskCard from 'src/app/general/user-tasks/parts/task-card';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { DateView } from 'src/core/ui/date.view';

interface Props extends ComponentViewProps<DataSet<UserTaskSummary>> {
	onItemDoubleClick: (item: UserTaskSummary) => void;
	onRemove: (item: UserTaskSummary) => void;
	kanban: boolean;
	reload: () => void;
	onFilterChange: (key: keyof UserTaskSummary, value: any, filter: any) => void;
	useAssignedToFilter: boolean
}

interface State {
	status: any
	userId: any;
	before: Date | null;
	after: Date | null;
	priority: string | null;
}

@observer
export class UserTasksListView extends React.Component<Props, State> {
	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			status: { value: null, test: 'All' },
			userId: null,
			after: null,
			before: null,
			priority: null

		}
	}


	render() {
		const { model, setBusy } = this.props;


		return (
			<React.Fragment>
				<Row gutter={24} type="flex" justify="start">
					<Col xs={2}>
						<Button
							onClick={this.props.reload}
							style={{ margin: '10px', marginTop: '18px' }}
							icon="reload"
						/>
					</Col>
					<Col xs={5}>
						<DropdownView
							options={[
								{ value: 0, text: 'New' },
								{ value: 1, text: 'In progress' },
								{ value: 2, text: 'Finished' },
								{ value: 4, text: 'Cancelled' },
								{ value: 8, text: 'Out of date' }
							]}
							label='Task status'
							keyField='value'
							model={this.state.status.value}
							textField='text'
							onChanged={e => {
								this.setState({ status: e || { value: null, text: 'All' } });
								this.props.onFilterChange('state', e ? e.value : null, 'eq');
							}}
						/>

					</Col>
					{this.props.useAssignedToFilter &&<Col xs={7}>
						<UserEditorController
							label="Assigned to"
							mode={'edit'}
							isRole={false}
							value={this.state.userId ? this.state.userId.id : null}
							setBusy={this.props.setBusy}
							onChanged={e => {
								this.props.onFilterChange('assignedToId', e ? e.id : null, 'eq')
								this.setState({ userId: e });
							}}
						/>
					</Col>}
					<Col xs={5}>
						<DateView
							label='Deadline before'
							mode='edit'
							format='date-time'
							value={this.state.before}
							onChanged={e => {
								this.props.onFilterChange('daedline', e, 'lt');
								this.setState({ before: e, after: null });
							}}
							dateUsage="utc"
						/>
					</Col>
					<Col xs={5}>
						<DateView
							label='Deadline after'
							mode='edit'
							format='date-time'
							value={this.state.after}
							onChanged={e => {
								this.props.onFilterChange('daedline', e, 'gt');
								this.setState({ after: e, before: null });
							}}
							dateUsage="utc"
						/>
					</Col>
				</Row>
				<Divider style={{ margin: '5px' }} />
				<div className={"task-list " + (this.props.kanban ? 'kanban' : '')}>
					{
						this.props.model.items.map((item, index) => {
							return (
								<TaskCard
									onRemove={this.props.onRemove}
									item={item}
									key={"task-card" + item.id}
									onItemDoubleClick={this.props.onItemDoubleClick}
								/>
							);
						})
					}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/list/user-tasks.list.view.tsx